import { ReactNode } from 'react';

type MenuItemWithComponent = {
  component: ReactNode;
  onClick(): void;
  disabled?: boolean;
  withDivider?: boolean;
  inline?: boolean;
  'data-testid'?: string;
};

export type MenuItemWithText = {
  text: string;
  color?: ({} & string) | 'danger';
  icon?: ReactNode;
  onClick?(): void;
  disabled?: boolean;
  direction?: 'left' | 'right';
  severity?: 'default' | 'danger';
  withDivider?: boolean;
  /** Whether the menu item is displayed inline next to the more actions button */
  inline?: boolean;
  'data-testid'?: string;
};

export type NestedMenuItemWithText = MenuItemWithText & {
  nestedItems: MenuItemType[];
};

export type MenuItemType = MenuItemWithComponent | MenuItemWithText | NestedMenuItemWithText;

export const isMenuItemWithText = (item: MenuItemType): item is MenuItemWithText =>
  (item as MenuItemWithText).text !== undefined;

export const isMenuItemWithComponent = (item: MenuItemType): item is MenuItemWithComponent =>
  (item as MenuItemWithComponent).component !== undefined;

export const isNestedMenuItemWithText = (item: MenuItemType): item is NestedMenuItemWithText =>
  isMenuItemWithText(item) && (item as NestedMenuItemWithText).nestedItems !== undefined;
